import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPage/getError'
import useCadastralFields from './useCadastralFields'

const CadastralFields = () => {
  const {
    t,
    errors,
    isEditable,
    cadastralSheetNumber,
    cadastralParcelNumber,
    cadastralSubunitNumber,
    hidden,
    updateAddress,
  } = useCadastralFields()

  if (hidden) return null

  return (
    <>
      <SDFormControl error={getError('cadastralSheetNumber', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.sheet_number')}
          disabled={isEditable === false}
          currentValue={cadastralSheetNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastralSheetNumber: value ?? '' })}
          error={getError('cadastralSheetNumber', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('cadastralParcelNumber', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.parcel_number')}
          disabled={isEditable === false}
          currentValue={cadastralParcelNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastralParcelNumber: value ?? '' })}
          error={getError('cadastralParcelNumber', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('cadastralSubunitNumber', errors)}>
        <SDInput
          label={t('subscriptionForm:address_module.cadastral_fields.subunit_number')}
          disabled={isEditable === false}
          currentValue={cadastralSubunitNumber ?? ''}
          onBlur={(value: string | null) => updateAddress({ cadastralSubunitNumber: value ?? '' })}
          error={getError('cadastralSubunitNumber', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>
    </>
  )
}

export default CadastralFields
